export const statusSelect = [
  'ATIVO',
  'INATIVO'
]

export const tipoInsumoSelect = [ 
  'MATERIAL DE ESCRITÓRIO', 
  'MATERIAL DE EXPEDIENTE', 
  'MATERIAL DE HIGIENE PESSOAL', 
  'MATERIAL DE LIMPEZA',
  'MATERIAL DE SANEANTE', 
  'MATERIAL IMPRESSO', 
  'MATERIAL LABORATORIAL E COLETA', 
  'MATERIAL MÉDICO E HOSPITALAR', 
  'MATERIAL ODONTOLÓGICO', 
  'MATERIAL DE DEMANDA E JUSTIFICATIVA',
]

export const tipoMedicamentoSelect = [
  'MEDICAMENTO ESSENCIAL',
  'MEDICAMENTO DE EMERGÊNCIA'
]

export const apresentacaoInsumosSelect = [
  'BLOCO',
  'ENVELOPE',
  'FOLHA',
  'FRASCO',
  'KG',
  'KIT',
  'LITRO',
  'PACOTE',
  'PAR',
  'RESMA',
  'ROLO',
  'TESTE',
  'TIRA',
  'UNIDADE',
]

export const apresentacaoMedicamentosSelect = [
  'AMP',
  'BISN',
  'BOL',
  'CAPS',
  'CP',
  'DRÁGEA',
  'ENV',
  'F/A',
  'FR',
  'GALÃO',
  'SER',
  'SUP',
  'TUB',
  'UNID',
]

export const segmentoSelect = [
  'ODONTO',
  'PMF',
  'RAPS',
  'SRT',
]
